/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Filter2 = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 18 17">
      <path d="M17 1.5L1 1.5C.723857625 1.5.5 1.27614237.5 1 .5.723857625.723857625.5 1 .5L17 .5C17.2761424.5 17.5.723857625 17.5 1 17.5 1.27614237 17.2761424 1.5 17 1.5zM13 6.5L1 6.5C.723857625 6.5.5 6.27614237.5 6 .5 5.72385763.723857625 5.5 1 5.5L13 5.5C13.2761424 5.5 13.5 5.72385763 13.5 6 13.5 6.27614237 13.2761424 6.5 13 6.5zM9 11.5L1 11.5C.723857625 11.5.5 11.2761424.5 11 .5 10.7238576.723857625 10.5 1 10.5L9 10.5C9.27614237 10.5 9.5 10.7238576 9.5 11 9.5 11.2761424 9.27614237 11.5 9 11.5zM5 16.5L1 16.5C.723857625 16.5.5 16.2761424.5 16 .5 15.7238576.723857625 15.5 1 15.5L5 15.5C5.27614237 15.5 5.5 15.7238576 5.5 16 5.5 16.2761424 5.27614237 16.5 5 16.5z" />
    </BaseSvgIcon>
  )
}

export default Filter2
